import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { StarFilled } from '@ant-design/icons';

import './product-specification.scss';

interface ProductSpecificationProps {
    description: string;
    score: number;
}

const ProductSpecification = ({ description, score }: ProductSpecificationProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <li className="product-specification">
            <label className="product-specification__label">{description}</label>
            <Tooltip title={t(`SCROLLABLE_AREA.MATERIAL.RATINGS.${[score - 1]}`)}>
                {!isNaN(score)
                    ? Array(score)
                          .fill(0)
                          .map((_, index) => <StarFilled className="product-specification__star" key={index} />)
                    : null}
            </Tooltip>
        </li>
    );
};

export default ProductSpecification;
